<template>
  <div class="tab-content">
    <div class="pick-date-container">
      <div class="input_wrapper">
        <div class="pick-date-container_label">Ngày</div>
        <DatePicker
          v-model="rangeDate"
          :range="true"
          :clearable="false"
          format="DD/MM/YYYY"
          placeholder="DD/MM/YYYY ~ DD/MM/YYYY"
          value-type="format"
          @change="handleDateSelect()"
        >
        </DatePicker>
      </div>
    </div>
    <div class="effort-chart">
      <div class="verticaltext_content">Effort (%)</div>
      <CChartLine
        class="chart-line"
        :datasets="line.datasets"
        :options="getOptionChart()"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import ResourceDetailLayout from "./ResourceDetailLayout.vue";
import moment from "moment";
import { CChartLine } from "@coreui/vue-chartjs";

export default {
  name: "ResourceEffort",
  components: {
    ResourceDetailLayout,
    DatePicker,
    CChartLine,
  },
  computed: {
    ...mapGetters({
      employeeEffort: "projectManagement/employeeEffort",
      resourceEffortDates: "project/resourceEffortDates"
    }),
  },
  data() {
    return {
      rangeDate: [
        moment().subtract(18, "days").format("DD/MM/YYYY"),
        moment().format("DD/MM/YYYY"),
      ],
      line: {
        datasets: [
          {
            label: "My Dataset",
            fill: false,
            lineTension: 0,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "#FF9B6A",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#FF9B6A",
            pointBackgroundColor: "#FF9B6A",
            pointBorderWidth: 10,
            pointHoverRadius: 7,
            pointHoverBackgroundColor: "#FF9B6A",
            pointHoverBorderColor: "#FF9B6A",
            pointHoverBorderWidth: 1,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [],
          },
        ],
      },
      maxX: "",
      minX: "",
    };
  },
  async created() {
    this.setLoading(true);
    await this.getEmployeeEffort({
      data: {
        startDate: this.resourceEffortDates.startDate,
        endDate: this.resourceEffortDates.endDate
      },
      id: this.$route.params.id,
    });
    this.setDate();
    this.setDataEffort();
    this.setLoading(false);
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    ...mapActions("projectManagement", ["getEmployeeEffort"]),
    ...mapActions("project", ["setStartEndDate"]),
    async handleDateSelect() {
      await this.getEmployeeEffort({
        data: {
          startDate: moment(this.rangeDate[0], "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          endDate: moment(this.rangeDate[1], "DD/MM/YYYY").format("YYYY-MM-DD"),
        },
        id: this.$route.params.id,
      });
      this.setStartEndDate({
        start_date: moment(this.rangeDate[0], "DD/MM/YYYY").format("YYYY-MM-DD"),
        end_date: moment(this.rangeDate[1], "DD/MM/YYYY").format("YYYY-MM-DD"),
      });
      this.setDataEffort();
    },
    setDate() {
      this.rangeDate = [moment(this.resourceEffortDates.startDate, 'YYYY-MM-DD').format("DD/MM/YYYY"),
        moment(this.resourceEffortDates.endDate, 'YYYY-MM-DD').format("DD/MM/YYYY")];
    },
    getOptionChart() {
      const employeeEffort = this.employeeEffort;
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltips: {
          enabled: false,
          custom: function (tooltipModel, efforts = employeeEffort) {
            // Tooltip Element
            let tooltipEl = document.getElementById("chartjs-tooltip");

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.innerHTML = "<table></table>";
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add("no-transform");
            }

            // Set Text
            if (tooltipModel.body) {
              const titleLines = tooltipModel.title || [];
              // const bodyLines = tooltipModel.body.map(getBody);

              let innerHtml = "<thead style='margin-bottom: 10px'>";

              titleLines.forEach(function (title) {
                innerHtml +=
                  "<tr><th>" +
                  moment(Number(title)).format("DD/MM/YYYY") +
                  "</th></tr>";
              });
              innerHtml += "</thead><tbody>";

              const date = moment(Number(titleLines[0])).format("YYYY-MM-DD");
              Object.keys(efforts[date]).forEach((key) => {
                if (key !== "total_effort") {
                  const colorCircle =
                    efforts[date][key].set_value === 1 ? "#17A896" : "#FF5555";
                  const divCircle =
                    "<div style='width: 6px; height: 6px; background-color: " +
                    colorCircle +
                    "; border-radius: 6px; margin-right: 8px'></div>";
                  const divText =
                    "<div style='margin-right: 8px'>Dự án: " +
                    efforts[date][key].project_name +
                    " - " +
                    efforts[date][key].effort +
                    "%</div>";
                  innerHtml +=
                    "<tr style='padding-bottom: 5px; height: 20px'><td><div style='display: flex; align-items: center; color: #303C54; font-size: 14px; font-weight: 400; line-height: 17px'>" +
                    divCircle +
                    divText +
                    "</div></td></tr>";
                }
              });
              innerHtml += "</tbody>";
              innerHtml +=
                "<div style='border-top: 1px solid #EAEAEA; margin-top: 7px; margin-bottom: 7px'></div>";
              innerHtml +=
                "<div style='display: flex; align-items: center'>" +
                "<div style='width: 6px; height: 6px; background-color: #17A896; border-radius: 6px; margin-right: 4px'></div>" +
                "<div style='color: #727E96; margin-right: 9px'>Tạo value</div>" +
                "<div style='width: 6px; height: 6px; background-color: #FF5555; border-radius: 6px; margin-right: 4px'></div>" +
                "<div style='color: #727E96'>Chưa tạo value</div>" +
                "</div>";

              let tableRoot = tooltipEl.querySelector("table");
              tableRoot.innerHTML = innerHtml;
            }

            // `this` will be the overall tooltip
            const position = this._chart.canvas.getBoundingClientRect();
            const canvasWidth = this._chart.canvas.width;

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = "absolute";
            tooltipEl.style.background = "#FFFFFF";
            tooltipEl.style.color = "#303C54";

            if (position.left + window.pageXOffset + tooltipModel.caretX - 50 - canvasWidth > 130) {
              tooltipEl.style.left = canvasWidth + position.left - 210 + "px";
            } else {
              tooltipEl.style.left =
                position.left +
                window.pageXOffset +
                tooltipModel.caretX -
                50 +
                "px";
            }
            if (
              Number(
                position.left + window.pageXOffset + tooltipModel.caretX - 50
              ) < 0
            ) {
              tooltipEl.style.left =
                position.left + window.pageXOffset + tooltipModel.caretX + "px";
            }
            tooltipEl.style.top =
              position.top + window.pageYOffset + tooltipModel.caretY + 8 + "px";
            tooltipEl.style.fontFamily = "Helvetica Neue";
            tooltipEl.style.fontSize = "14px";
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding =
              tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.border = "1px solid rgba(0, 0, 0, 0.14)";
            tooltipEl.style.borderRadius = "10px";
            tooltipEl.style.minWidth = "210px";
          },
        },
        scales: {
          yAxes: [
            {
              fontSize: 14,
              gridLines: {
                display: true,
                borderDash: [5, 5],
                // drawBorder: true,
                // offsetGridLines: false
              },
              ticks: {
                min: 0,
                max: 200,
                stepSize: 20,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              type: "linear",
              position: "bottom",
              ticks: {
                userCallback: function (label, index, labels) {
                  return moment(label).format("D/M");
                },
                min: this.minX,
                max: this.maxX,
                stepSize: 86400000
              },
            },
          ],
        },
      };
    },
    setDataEffort() {
      this.line.datasets[0].data = [];
      if (this.rangeDate[0] !== this.rangeDate[1]) {
        this.minX = moment(this.rangeDate[0], "DD/MM/YYYY").valueOf();
        this.maxX = moment(this.rangeDate[1], "DD/MM/YYYY").valueOf();
        if (Object.keys(this.employeeEffort).length > 0) {
          Object.keys(this.employeeEffort).forEach((key, index) => {
            const day = moment(key, "YYYY-MM-DD").valueOf();
            this.line.datasets[0].data.push({
              x: day,
              y: this.employeeEffort[key].total_effort,
            });
          });
        }
      } else {
        this.minX = moment(this.rangeDate[0], "DD/MM/YYYY").valueOf() - 86400000;
        this.maxX = moment(this.rangeDate[1], "DD/MM/YYYY").valueOf() + 86400000;
        if (Object.keys(this.employeeEffort).length > 0) {
          Object.keys(this.employeeEffort).forEach((key, index) => {
            const day = moment(key, "YYYY-MM-DD").valueOf();
            this.line.datasets[0].data.push({
              x: day,
              y: this.employeeEffort[key].total_effort,
            });
          });
        }

      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-content {
  padding-top: 16px;
  background: #ffffff;
  border-radius: 0 0 10px 10px;
  .pick-date-container {
    display: flex;
    justify-content: end;
    margin-bottom: 10px;
    .input_wrapper {
      padding-right: 20px;
      min-width: 220px;
    }
    &_label {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #303c54;
    }
  }
  .effort-chart {
    height: 590px;
    position: relative;
    .verticaltext_content {
      position: absolute;
      left: 0;
      top: -25px;
      width: 100px;
      font-size: 13px;
      font-family: "Helvetica Neue";
    }
    .chart-line {
      width: 100%;
      height: 100%;
    }
  }
  #chartjs-tooltip {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 3px;
    border-radius: 3px;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
    pointer-events: none;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
}
</style>
